import { useEffect, useRef, useState } from "react"
import styled from "styled-components/macro"
import { EffectFade, Navigation, Pagination } from "swiper/modules"
import { Swiper, SwiperSlide } from "swiper/react"
import "swiper/css"
import "swiper/css/effect-fade"
import "swiper/css/navigation"
import "swiper/css/pagination"

const Info2Carousel = ({ info2Data }) => {
  const swiperRef = useRef(null)
  const [currentInfoIndex, setCurrentInfoIndex] = useState(0)

  return (
    <Wrapper>
      <Swiper
        onSwiper={(swiper) => {
          swiperRef.current = swiper
        }}
        effect="fade"
        className="bgImage"
        spaceBetween={0}
        slidesPerView={1}
        centeredSlides={true}
        onSlideChange={(_swiper) => setCurrentInfoIndex(_swiper.activeIndex)}
        fadeEffect={{ crossFade: true }}
        modules={[EffectFade]}
        speed={1000}
        style={{ height: "100%", width: "100%" }}
      >
        {info2Data?.block.map((content, index) => (
          <SwiperSlide
            key={content?.img + index?.toString()}
            style={{
              display: "flex",
              justifyContent: "end",
              alignItems: "center",
              width: "100%",
            }}
          >
            <img
              style={{
                width: "40%",
                height: "100%",
                objectFit: "cover",
              }}
              alt={content?.img}
              src={content?.img}
            />
          </SwiperSlide>
        ))}
      </Swiper>
      <div className="copy">
        <div className="mainText">
          <div className="headline">
            {info2Data?.block[currentInfoIndex]?.headline
              .split(" ")
              .map((word, index) => (
                <span key={index} className={index === 0 ? "styled" : ""}>
                  {word} {index === 0 && <br />}{" "}
                </span>
              ))}
          </div>
          <div className="body">{info2Data?.block[currentInfoIndex]?.body}</div>
        </div>
      </div>
      <div className="controls">
        <div className="button">
          <div
            onClick={() => {
              if (currentInfoIndex > 0)
                setCurrentInfoIndex(currentInfoIndex - 1)
              swiperRef.current.slideTo(currentInfoIndex - 1)
            }}
          >
            {" "}
            <img src="/assets/icons/back.svg" alt="" />
          </div>
          <div
            onClick={() => {
              if (currentInfoIndex + 1 !== info2Data?.block?.length) {
                setCurrentInfoIndex(currentInfoIndex + 1)
                swiperRef.current.slideTo(currentInfoIndex + 1)
              } else {
                setCurrentInfoIndex(0)
                swiperRef.current.slideTo(0)
              }
            }}
          >
            <img
              src="/assets/icons/back.svg"
              style={{ transform: "rotate(180deg)" }}
              alt=""
            />
          </div>
        </div>
        {/* <div className="timeline">
          {info2Data?.block?.map((headline, index) => (
            <div
              onClick={() => {
                setCurrentInfoIndex(index), swiperRef.current.slideTo(index)
              }}
              className={index === currentInfoIndex ? "active" : ""}
            >
              {headline.headline}
            </div>
          ))}
        </div> */}
        <div className="index">
          {currentInfoIndex + 1}/{info2Data?.block?.length}
        </div>
      </div>
    </Wrapper>
  )
}

export default Info2Carousel

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  .bgImage {
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 0;
  }

  .copy {
    width: 90%;
    height: 70%;
    display: flex;
    align-items: center;
    color: #252525d6;
    z-index: 1;
    pointer-events: none;
    margin: 0 8rem;
    margin-top: auto;

    .mainText {
      padding: 0 2rem;
      border-left: 1px solid #2525252a;
      width: 50%;
      display: flex;
      flex-direction: column;
      gap: 4rem;

      .headline {
        font-size: 4rem;
        line-height: 55px;

        .styled {
          font-size: 6rem;
          font-style: italic;
        }
      }

      .body {
        font-size: 1.5rem;
        line-height: 35px;
      }
    }
  }

  .controls {
    width: 100%;
    height: 15%;
    display: flex;
    justify-content: space-between;
    align-items: start;
    gap: 5rem;
    z-index: 1;
    padding: 2rem 8rem;

    .button {
      display: flex;
      gap: 1rem;
      cursor: pointer;

      div {
        background-color: #252525d6;
        padding: 1rem;
        color: #fff;
        width: 4rem;
        height: 4rem;
        border-radius: 2rem;
        img {
          width: 100%;
          height: 100%;
          padding: 0.5rem;
        }
        &:active {
          opacity: 0.75;
          transform: scale(0.95);
          transition: 0.3s;
        }
      }
    }

    .timeline {
      display: flex;
      color: #ffffff73;
      gap: 2rem;
      transition: 0.3s;
      cursor: pointer;

      .active {
        color: white;
        transition: 0.3s;
      }
    }

    .index {
      font-size: 2rem;
      color: white;
      letter-spacing: 5px;
    }
  }
`
